<template>
  <img :src="dealershipLogo" alt="logo" class="img-fluid mb-3" />

  <div v-show="isIPhone || isAndroid" class="container">
    <div v-if="isIPhone">
      <h2>Create Apple Wallet Pass</h2>
    </div>
    <div v-if="isAndroid">
      <h2>Create Google Wallet Pass</h2>
    </div>

    <form class="text-start mb-5" @submit.prevent="submitAppleData">
      <div class="mb-3">
        <label for="dealershipName" class="form-label">Dealership Name</label>
        <input
          type="text"
          :disabled="isDisabled"
          class="form-control"
          v-model="dealershipName"
          id="dealershipName"
          placeholder="Dealership Name"
          required
        />
      </div>

      <div class="mb-3">
        <label for="barcodeNumber" class="form-label">Barcode Number</label>
        <input
          type="text"
          :disabled="isDisabled"
          class="form-control"
          id="barcodeNumber"
          inputmode="numeric"
          v-model="barcodeNumber"  
          maxlength="19"
         @input="!barcodePrefilled && checkLength()"
          placeholder="Enter Barcode Number"
          required
        />
        <p
          v-if="message"
          :class="tokenStatus === 'success' ? 'text-success' : 'text-danger'"
        >
          {{ message }}
        </p>
      </div>

      <div class="mb-3">
        <label for="firstName" class="form-label">First Name</label>
        <input
          type="text"
          :disabled="isDisabled"
          class="form-control"
          id="firstName"
          v-model="firstName"
          placeholder="Enter First Name"
          required
        />
      </div>

      <div class="mb-3">
        <label for="lastName" class="form-label">Last Name</label>
        <input
          type="text"
          :disabled="isDisabled"
          class="form-control"
          id="lastName"
          v-model="lastName"
          placeholder="Enter Last Name"
          required
        />
      </div>

      <div class="mb-3">
        <label for="year" class="form-label">Year</label>
        <input
          type="number"
          :disabled="isDisabled"
          class="form-control"
          id="year"
          v-model="year"
          placeholder="Enter Year"
          required
        />
      </div>

      <div class="mb-3">
        <label for="make" class="form-label">Make</label>
        <input
          type="text"
          :disabled="isDisabled"
          class="form-control"
          id="make"
          v-model="make"
          placeholder="Enter Make"
          required
        />
      </div>

      <div class="mb-3">
        <label for="model" class="form-label">Model</label>
        <input
          type="text"
          :disabled="isDisabled"
          class="form-control"
          id="model"
          v-model="model"
          placeholder="Enter Model"
          required
        />
      </div>

      <!-- Here comes RECAPTCHA  -->
      <div class="mb-3">
        <RecaptchaV2
          :site-key="recaptchaSiteKey"
          @verified="onCaptchaVerified"
          @expired="onCaptchaExpired"
          @error="onCaptchaError"
        />
      </div>

      <div v-if="isLoading" class="text-center mx-auto">
        <img
          alt="loading"
          class="img-fluid mx-auto"
          :class="tokenStatus === 'success' ? 'd-block' : 'd-none'"
          src="../assets/loading.gif"
        />
      </div>

      <div v-else>
        <div v-if="isIOS">
          <button
            type="button"
            :disabled="!captchaVerified"
            class="btn"
            :class="tokenStatus === 'success' ? 'd-block' : 'd-none'"
            @click="submitAppleData"
          >
            <img
              class="img-fluid"
              alt="apple-wallet-logo"
              src="../assets/add_to_apple_wallet.png"
            />
          </button>
        </div>

        <div v-if="isAndroid">
          <div v-if="isLoading" class="text-center mx-auto">
            <img
              alt="loading"
              class="img-fluid mx-auto"
              :class="tokenStatus === 'success' ? 'd-block' : 'd-none'"
              src="../assets/loading.gif"
            />
          </div>

          <div v-if="responseStatus == 'success'"></div>
          <div v-else>
            <button
              type="button"
              :disabled="!captchaVerified"
              class="btn"
              @click="submitGoogleData"
              style="border-style: solid; border-width: thin; border-color: black;"
            >
              Submit
            </button>
          </div>
        </div>
      </div>
    </form>

    <div v-if="isIOS">
      <div
        v-if="responseMessage"
        class="mt-3 alert"
        :class="responseStatus === 'success' ? 'alert-success' : 'alert-danger'"
      >
        {{ responseMessage }}
      </div>
    </div>
    <div v-else-if="isAndroid">
      <div
        v-if="responseMessage"
        class="mt-3 alert"
        :class="responseStatus === 'success' ? 'alert-success' : 'alert-danger'"
      >
        <div v-html="responseMessage"></div>
      </div>
    </div>
  </div>

  <div v-show="!(isIPhone || isAndroid)">
    <p class="m-3 mx-auto container alert alert-danger">
      We are sorry. Your device does not support Apple Wallet or Google Wallet. This feature is available exclusively on Apple iPhone or Android devices.
    </p>
  </div>
</template>

<script>
import axios from "axios";
import { ref as storageRef, getDownloadURL, deleteObject } from "firebase/storage";
import { storage } from "@/firebase";
import RecaptchaV2 from "@/components/RecaptchaV2.vue";

export default {
  name: "CreatePass",

  components: {
    RecaptchaV2
  },

  data() {
    return {
      dealershipName: "",
      logoMap: {
        fredbeans: require("@/assets/logo-fredbeans.png")
      },
      defaultLogo: require("@/assets/logo.png"),
      barcodeNumber: "",
      firstName: "",
      lastName: "",
      make: "",
      model: "",
      year: "",
      responseMessage: "",
      responseStatus: "",
      tokenStatus: "",
      message: "",
      isIOS: false,
      isIPhone: false,
      isAndroid: false,
      isLoading: false,
      hideLoading: false,
      isDisabled: false,
      captchaVerified: false,
      captchaToken: "",
      barcodePrefilled: false,
      recaptchaSiteKey: "6LcyMFMsAAAAAHplzVhrGyBkxx3Lp5_Dfi5QyIMa"
    };
  },

  async mounted() {
    document.title = "Your-AutoAwards-Wallet";

    this.isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
    this.isIPhone = /iPhone|iPod/i.test(navigator.userAgent);
    this.isAndroid = /android/i.test(navigator.userAgent);

    const url = new URL(window.location.href);
    const queryParams = new URLSearchParams(url.search);
    const barcodeFromUrl = queryParams.get("barcodeNum");
    this.dealershipName = queryParams.get("dealership") || "";
    this.barcodeNumber = queryParams.get("barcodeNum") || "";
    this.firstName = queryParams.get("firstna") || "";
    this.lastName = queryParams.get("lastna") || "";
    this.year = queryParams.get("year") || "";
    this.make = queryParams.get("make") || "";
    this.model = queryParams.get("model") || "";
    this.barcodePrefilled = !!(barcodeFromUrl && barcodeFromUrl.trim().length);
    if (this.barcodePrefilled) {
    this.tokenStatus = "success";
    this.message = "";
    this.isLoading = false;
  }
  },

  created() {
    const params = new URLSearchParams(window.location.search);
    if (params.get("readonly") === "true") {
      this.isDisabled = true;
    }
  },

computed: {
  dealerSlug() {
    const host = window.location.hostname.toLowerCase();

    // Match subdomain
    const match = host.match(/^([a-z0-9-]+)wallet\.yourautoawards\.com$/);

    return match ? match[1] : null;
  },

  dealershipLogo() {
    return this.logoMap[this.dealerSlug] || this.defaultLogo;
  }
},

  methods: {

    //captcha events
    onCaptchaVerified(token) {
      this.captchaToken = token;
      this.captchaVerified = true;
    },
    onCaptchaExpired() {
      this.captchaToken = "";
      this.captchaVerified = false;
    },
    onCaptchaError() {
      this.captchaToken = "";
      this.captchaVerified = false;
    },


    //sanity check for barcode number
async checkLength() {
    if (this.barcodePrefilled) {
    this.tokenStatus = "success";
    this.message = "";
    return;
  } else if(this.barcodeNumber.length === 19){
  const tokenNum = this.barcodeNumber || "";
  this.tokenStatus = "";
  this.message = "";
  this.isLoading = true;
  this.message = "Checking barcode...";
  try {
    const response = await axios.post(
      "https://us-central1-autorewards-1fc69.cloudfunctions.net/closedAccounts-closedAccountsChecker",
      { qrText: tokenNum }
    );

    const status = response?.data?.acstatus;

    if (status === "CLOSED") {
      this.tokenStatus = "error";
      this.isLoading = true;
      alert("This account is closed. Please reach out to your dealership to activate this account. Thank you.");
      this.barcodeNumber = '';
      this.message = "";
      return;
    }

    if (["IDLE", "ACTIVE", "OPEN", "GRACE"].includes(status)) {
      this.tokenStatus = "success";
      this.message = "Your Barcode Number is Valid";
    } else if (status == null){
      this.tokenStatus = "error";
      this.message = "Your Barcode Number is not matching our records";
      this.isLoading = false;
    }
  } catch (e) {
    console.error(e);
    this.tokenStatus = "error";
    this.message = "Failed to check account status. Please try again.";
  } finally {
    this.isLoading = false;
  }
  } else if(this.barcodeNumber.length < 19){
    this.tokenStatus = "error";
    this.message = "Barcode Number should be 19 digits";
  }
},

 //now function named apple
    async submitAppleData() {
      if (!this.captchaVerified || !this.captchaToken) {
        this.responseMessage = "Please complete the reCAPTCHA checkbox.";
        this.responseStatus = "error";
        return;
      }

      const jsonData = {
        dealerName: this.dealershipName,
        qrText: this.barcodeNumber,
        thumbnail: "https://upload.wikimedia.org/wikipedia/commons/5/59/Empty.png",
        primary: {
          value: this.firstName + " " + this.lastName,
          label: "Member Name"
        },
        secondary: [
          { value: this.dealershipName, label: " " },
          { value: " ", label: " " }
        ],
        auxiliary: [
          { value: this.barcodeNumber, label: "Rewards Account" },
          { value: this.make + " " + this.model, label: this.year?.toString() }
        ],
        backgroundColor: "#111111",
        textColor: "#ffffff"
      };

      try {
        const response = await axios.post(
          "https://passcreator-2slwxmvyva-uc.a.run.app",
          jsonData
        );
        console.log(response.data);

        this.isLoading = true;

        const fileRef = storageRef(
          storage,
          "passes_v2/" + this.barcodeNumber + ".pkpass"
        );
        const url = await getDownloadURL(fileRef);
        window.open(url, "_self");

        this.responseMessage = "Data submitted successfully!";
        this.responseStatus = "success";
        this.tokenStatus = "success";
        this.isLoading = false;

        setTimeout(async () => {
          try {
            await deleteObject(fileRef);
            console.log("Pass deleted from storage.");
          } catch (err) {
            console.error("Error deleting pass:", err);
          }
        }, 3000);
      } catch (error) {
        this.responseMessage = "Failed to submit data. Please try again.";
        this.responseStatus = "error";
        console.error("Error submitting data:", error);
        this.isLoading = false;
      }
    },
 // function named google
    async submitGoogleData() {
      if (!this.captchaVerified || !this.captchaToken) {
        this.responseMessage = "Please complete the reCAPTCHA checkbox.";
        this.responseStatus = "error";
        return;
      }

      const fullBarcode = this.barcodeNumber;


      // Split barcode
      const barCode = fullBarcode.substring(0, 7);
      const b1 = fullBarcode.substring(7, 11);
      const b2 = fullBarcode.substring(11, 15);
      const b3 = fullBarcode.substring(15, 18);
      const b4 = fullBarcode.substring(18, 19);

      const jsonGoogleData = {       
          barCode: barCode,
          b1: b1,
          b2: b2,
          b3: b3,
          b4: b4,

          dealerName: this.dealershipName,
          firstName: this.firstName,
          lastName: this.lastName,
          make: this.make,
          model: this.model,
          year: this.year,
      };

      try {
        const response = await axios.post(
           "https://dev-google-wallet.brooke.ai/google-wallet/rewards",
           jsonGoogleData
        );

        this.isLoading = true;
        this.responseMessage = `<a href='${response.data.status}'><img src="/wallet-button.png" style="width: -webkit-fill-available; width: -moz-available; width: fill-available; max-width: 100%;"a>`;//;`${response.data.status}`;
        this.responseStatus = "success";
        this.link = `${response.data.status}`;
        this.tokenStatus = "success";
        this.isLoading = false;
      } catch (error) {
        this.responseMessage = "Failed to submit data. Please try again.";
        this.responseStatus = "error";
        console.error("Error submitting data:", error);
        this.isLoading = false;
      }
    }
  }
};
</script>

<style scoped>
.container {
  max-width: 600px;
  margin: 0 auto;
  padding-top: 20px;
}

.alert {
  font-size: 16px;
}

.btn {
  border-style: solid;
  border-width: thin;
  border-color: black;
}
</style>
